import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import BreadCrumb from "components/breadcrumb/BreadCrumb";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { RolesAPI, UpdateProfileAPI } from "api";
import { toast } from "react-toastify";
import { useAppContext } from "Main";
import { useFetchRoles } from "hooks/useFetchRoles";
import Banner from "../Banner";

const schema = yup
  .object({
    name: yup.string().required("This field is required."),
    loginId: yup.string().required("This field is required."),
    // roleName: yup.string(),
    role: yup.string().required("This field is required."),
    type: yup.string().required("This field is required."),
    designation: yup.string().required("This field is required."),
  })
  .required();

const UserProfile = () => {
  const [user, setUser] = useState({});
  // const [userRoleName, setUserRoleName] = useState("");
  const userFound = JSON.parse(localStorage.getItem("user"));

  const { data: roles, isFetching, isLoading } = useFetchRoles();

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: userFound
      ? {
          name: userFound.name || "",
          loginId: userFound.loginId || "",
          role: userFound.role || "",
          type: userFound.type || "",
          designation: userFound.designation || "",
        }
      : {},
  });
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = methods;

  const onSubmit = async (data) => {
    console.log(data);
    let myData = { ...data };
    const roleName = roles?.data.data.find((d) => d.id == data.role);
    {
      myData.password = "";
      myData.roleName = roleName ? roleName?.name : "";
      myData.email = "";
      myData.avatar = "";
      //   "avatar": "string"

      // {
      //   "loginId": "string",
      //   "password": "string",
      //   "type": "string",
      //   "role": 0,
      //   "roleName": "string",
      //   "name": "string",
      //   "designation": "string",
      //   "email": "string",
      //   "avatar": "string"
      // }
    }

    console.log(myData);
    try {
      await UpdateProfileAPI.post(myData);
      toast.success("Posted", { position: "top-right", autoClose: 2000 });
    } catch (error) {
      toast.error("Something Wrong", {
        position: "top-right",
        autoClose: 2000,
      });
      console.log(error);
    }
  };

  if (isFetching || isLoading) {
    return <Spinner animation="border" variant="primary" />;
  }

  // useEffect(() => {
  //   if (location.state) {
  //     reset(location.state);
  //   }
  // }, []);

  // useEffect(() => {
  //   // const userFound = localStorage.getItem("user");
  //   if (!!userFound) {
  //     setLoading(true);
  //     setTimeout(() => reset(userFound), [2000]);
  //     setLoading(false);
  //   }
  // }, []);

  return (
    <>
      <Banner />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card className="mb-3 ">
            <Card.Header as="h6" className="bg-body-tertiary">
              Basic information
            </Card.Header>
            <Card.Body>
              <Row className="gy-3 gx-0">
                <Col md="12">
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Full Name"
                      className=""
                    >
                      <Form.Control
                        type="text"
                        placeholder=""
                        isInvalid={!!errors.name}
                        {...register("name")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name?.message}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>
                </Col>

                <Col md="12">
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Email Address"
                      className=""
                    >
                      <Form.Control
                        type="text"
                        placeholder="name@example.com"
                        isInvalid={!!errors.loginId}
                        {...register("loginId")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.loginId?.message}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>
                </Col>
                <Col md="12">
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Phone Number"
                      className=""
                    >
                      <Form.Control
                        type="text"
                        placeholder="Phone Number"
                        isInvalid={!!errors.designation}
                        {...register("designation")}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.designation?.message}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Row>
                <Col className="d-flex justify-content-end">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Ok
                    {/* Save */}
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default UserProfile;
